import React from 'react';
import { AgentHistoryItem } from '../../types/user';
import { Calendar, FileText } from 'lucide-react';

interface AgentHistoryCardProps {
  item: AgentHistoryItem;
  onClick?: () => void;
}

const AgentHistoryCard = ({ item, onClick }: AgentHistoryCardProps) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getAgentKindLabel = (kind: string) => {
    switch (kind) {
      case 'text-modal':
        return '텍스트 기반';
      case 'image-modal':
        return '이미지 기반';
      case 'gen-image-modal':
        return '이미지 생성';
      default:
        return kind;
    }
  };

  return (
    <div 
      className="bg-white rounded-xl shadow-sm border border-gray-100 px-4 py-4 lg:px-6 lg:py-5 hover:shadow-md transition-all cursor-pointer group"
      onClick={onClick}
    >
      <div className="flex gap-3 lg:gap-4">
        <div className="flex-shrink-0">
          <img
            src={item.agent_image}
            alt={item.agent_title}
            className="w-12 h-12 lg:w-16 lg:h-16 rounded-lg object-cover"
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between mb-2">
            <h3 className="text-base lg:text-lg font-semibold text-gray-900 group-hover:text-teal-600 transition-colors line-clamp-1 pr-2">
              {item.agent_title}
            </h3>
            <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full whitespace-nowrap flex-shrink-0">
              {getAgentKindLabel(item.agent_kind)}
            </span>
          </div>

          <p className="text-gray-600 text-sm mb-2 lg:mb-3 line-clamp-2">
            {item.agent_description}
          </p>

          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-xs lg:text-sm text-gray-500">
            <div className="flex items-center gap-1">
              <Calendar className="w-3 h-3 lg:w-4 lg:h-4" />
              <span className="truncate">{formatDate(item.created_at)}</span>
            </div>
            
            <div className="flex items-center gap-2">
            <div className="flex items-center gap-1">
                <FileText className="w-3 h-3 lg:w-4 lg:h-4" />
              <span>응답 완료</span>
            </div>

            {item.child_license && (
              <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded-full">
                아동용
              </span>
            )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgentHistoryCard; 